var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",class:( _obj = {
    '--grayed': _vm.color === 'grayed'
  }, _obj['background--' + _vm.game] = true, _obj['background--ddu'] =  _vm.platform === 'steam' || _vm.platform === 'galaxy', _obj )},[_c('div',{staticClass:"background__img"})])}
var staticRenderFns = []

export { render, staticRenderFns }